<template>
  <div class="df-container">
    <div class="mask" :class="{on:isShow}"></div>
    <div class="menu" :class="{tabBar:isTabBar,on:isShow}">
      <div class="title">{{info.title}}</div>
      <div class="list">
        <div class="item" v-for="(item,index) in info.items" :key="index" :class="{on:info.destructiveBtnIndex == index}" @click="confirm(index)">
          {{item}}
        </div>
      </div>
      <div class="cancelBtn" @click="confirm(-1)">{{info.cancelButtonText}}</div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
  export default {
    name: 'actionSheet',
    data: function () {
      return {
        isShow:false
      }
    },
    props: [
      'value',
      'info'
    ],
    computed: {
      ...mapState([
        'isTabBar'
      ]),
    },
    created() {
      setTimeout(()=>{
        this.isShow = this.value;
      })
    },
    mounted() {

    },
    watch: {},
    methods: {
      confirm(index){
        this.isShow = false;
        setTimeout(()=>{
          this.$emit("on-success",index);
        },300)
      }
    },
  }
</script>
<style lang="scss" scoped type="text/scss">
  @import "css/common";
  .mask{
    transition: opacity 0.2s ease;
    opacity:0;
    &.on{
      opacity:0.6
    }
  }
  .menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    font-size: 30px;
    transition: all 0.2s ease;
    background-color: #f2f2f2;
    transform: translateY(100%);
    &.on{
      transform: translateY(0);
    }
    &.tabBar{
      bottom: 110px;
    }
    .title{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      background-color: #fff;
      color: #8e8e8e;
      font-size:28px;
    }
    .list{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      background-color: #fff;
      .item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;
        border-top: solid 1px #e9e9e9;
        &:active{
          background-color: rgba(0,0,0,0.15);
        }
        &.on{
          color: #ff0000;
        }
      }
    }
    .cancelBtn{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      padding: 20px 0;
      box-sizing: border-box;
      background-color: #fff;
      &:active{
        background-color: rgba(0,0,0,0.15);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/flexible-ui/actionSheet.vue